import React from 'react'

function ContextMenuSeparator() {
  return (
    <li className='contextMenuSeparator'></li>
  )
}

export default ContextMenuSeparator